import { getUrlVars } from './';

function log(file, element, type = "log", always = true) {
	if (typeof getUrlVars().debug === "undefined" && !always) {
		return;
	}

	let filename = file.split("/");
	filename = filename[filename.length - 1];

	if (typeof element === "string") {
		console[type](`[${filename}]`, element);
	} else {
		console[type](`[${filename[filename.length - 1]}]`, Object.keys(element)[0], element[Object.keys(element)[0]]);
	}
}

export default log;
